// index.js

import React, { Suspense, useEffect, useState } from "react";
import ReactDOM from "react-dom";

import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";

import "./index.css";
import "./service/i18/i18n";
import axios from "axios";

// ثبت ماژول‌های Enterprise
ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey("your License Key");

//LicenseManager.setLicenseKey("your License Key");
 
// import { createRoot } from 'react-dom/client';

// setGlobalSettings()
const Loader = () => <div className="App">...</div>;

// Error boundary برای捕捉 خطاهای runtime در lazy-loaded ها
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught error:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return <div className="App">Something went wrong.</div>;
    }
    return this.props.children;
  }
}

ReactDOM.render(
  <ErrorBoundary>
    <Suspense fallback={<Loader />}>
      <OuterApp />
    </Suspense>
  </ErrorBoundary>,
  document.getElementById("root")
);

function OuterApp() {
  const [canLoad, setCanLoad] = useState(false)

  useEffect(() => {
    axios.post(
  `${process.env.NODE_ENV === 'production' ? window.location.origin : "https://dispatcher.swiftee.co.uk"}${/*"https://onro.app.onro.app/"*/""}/api/dispatcher/initial-setting`,
//   `${window.location.origin}/api/dispatcher/initial-setting`,
  // `https://dispatcher.onro.io/api/dispatcher/initial-setting`,

      {},
      {
        headers: {
          "Content-type": "application/json",
          "X-Api-Source": "web",
        },
      }
    )
      .then((res) => {
        try {
          global.config = {
            ...global.config,
            ...res.data.data,
            defaultLanguage:
              res.data.data.defaultLanguage == "ar" ||
              !res.data.data.defaultLanguage ||
              res.data.data.defaultLanguage == ""
                ? "en"
                : res.data.data.defaultLanguage,
            availableLanguages:
              ((res.data.data.availableLanguages?.length === 1 ||
                res.data.data.availableLanguages?.length === 0 ||
                !res.data.data.availableLanguages) &&
                (res.data.data.defaultLanguage == "ar" ||
                  !res.data.data.defaultLanguage ||
                  res.data.data.defaultLanguage == ""))
                ? ["en"]
                : res.data.data.availableLanguages,
          };
        } catch (error) {
          global.config = { ...global.config, ...res.data.data };
        }

        setTimeout(() => {
          setCanLoad(true)
         
        }, 400);
      })
  },[]);


//  TestWorker()

  let CompApp = canLoad ? require('./innerIndex').default : <></>;

  // let comp;
  // if(setGlobalSettings()) { comp = require('./App').default; }
  return (
    <React.Fragment>
      {canLoad ? <CompApp /> : null}
    </React.Fragment>
  );
}
